import React from "react";
import { Spin, Table } from "antd";
import CustomTabs from "../../../components/CustomTabs/CustomTabs";
import AdSearchForm from "../AdSearchForm";
import styles from "./manageAdPage.scss";
import { IndexPagination } from "../../../components/IndexPagination";
import { ShareLinkForm } from "./ShareLinkForm";
import { AD_DUPLICATE_TAB_KEY, AdStatus } from "../../../models";
import PageTitle from "../PageTitle";
import { ModulesI } from "../../../typings/routesTypes";
import { categoriesInterface, PriceChangeListParsed } from "../../../typings/interfaces";
import { SearchCriteriaI } from "./handleManageAdPage";
import { PriceChanges } from "./PriceChanges";
import StatusChanges from "./StatusChanges/StatusChanges";

interface ManageAdPageProps {
  history: History;
  location: Location;
  match: {
    path: string;
    url: string;
    isExact: true;
    params: {};
  };
  ads: {
    thumbnailImage: string;
    code: number;
    title: string;
    creatorId: string;
    username: string;
    postedDate: string;
    expirationDate: string;
    smartLink: string;
    module: string;
    category: string;
    id: string;
    status: number;
    is18Old: boolean;
    creator: string;
    isAgent: boolean;
  }[];
  total: number;
  page: number;
  itemPerPage: number;
  searchCriteria: SearchCriteriaI;
  adData: any;
  modules: ModulesI[];
  categories: categoriesInterface[];
  columns: {
    title: string;
    dataIndex: string;
    class: string;
    key: string;
    width: number;
  }[];
  showShareLinkForm: boolean;
  showPriceChanges: boolean;
  priceChangeValues: PriceChangeListParsed;
  onPriceChangesClose: () => void;
  onPriceChangesPageChange: (page: number, callback?: () => void) => void;
  formValues: {};
  getAdLinkData: () => void;
  getAdsAction: () => void;
  onFormSubmit: () => void;
  onPageChange: () => void;
  onSearch: () => void;
  onTabChange: () => void;
  searchAdsAction: () => void;
  toogleAd18Old: () => void;
  changeAdStatus: () => void;
  updateAdLink: () => void;
  getPriceChanges: () => void;
  isLoading: boolean;
  expandedRowRender: () => void;
  onExpandedRowsChange: () => void;
  expandedRowKeys: string[] | number[];
  expandedIcon: () => void;
  setStatusChangesAdId: (boolean) => void;
  statusChangesAdId: string | null;
  setStatusChangesPostedDate: (value: string | null) => void;
  statusChangesPostedDate: string | null;
}

const renderTabContent = (
  {
    ads,
    columns,
    total,
    page,
    itemPerPage,
    onPageChange,
    expandedRowRender,
    onExpandedRowsChange,
    expandedRowKeys,
    expandedIcon
  }
) => (
  <React.Fragment>
    <Table
      dataSource={ads}
      columns={columns}
      bordered
      pagination={false}
      rowKey="id"
      scroll={{ x: "100%" }}
      className={`admin-table admin-ad-table ${styles.table}`}
      expandIconColumnIndex={0}
      expandedRowRender={expandedRowRender}
      onExpandedRowsChange={onExpandedRowsChange}
      expandedRowKeys={expandedRowKeys}
      expandIconAsCell={false}
      expandIcon={expandedIcon}
    />
    <IndexPagination
      total={total}
      page={page}
      itemPerPage={itemPerPage}
      onPageChange={onPageChange}
    />
  </React.Fragment>
);

const ManageAdPage = (props: ManageAdPageProps) => {
  const {
    searchCriteria,
    onSearch,
    modules,
    categories,
    showShareLinkForm,
    showPriceChanges,
    priceChangeValues,
    onPriceChangesClose,
    onPriceChangesPageChange,
    onFormSubmit,
    formValues,
    onTabChange,
    isLoading,
    setStatusChangesAdId,
    statusChangesAdId,
    setStatusChangesPostedDate,
    statusChangesPostedDate,
    ...rest
  } = props;

  return (
    <React.Fragment>
      <PageTitle title={"Upravljaj Oglasima"} />
      <AdSearchForm
        data={searchCriteria}
        onSubmit={onSearch}
        modules={modules}
        categories={categories}
      />
      <div>

        <CustomTabs
          activeKey={searchCriteria.status && searchCriteria.status !== null ? searchCriteria.status.toString() : AdStatus.active.toString()}
          onChange={onTabChange}
          tabs={[
            { key: AdStatus.active.toString(), label: "Aktivan", content: renderTabContent(rest) },
            { key: AdStatus.paused.toString(), label: "Pauziran", content: renderTabContent(rest) },
            { key: AdStatus.sold.toString(), label: "Prodan", content: renderTabContent(rest) },
            { key: AdStatus.deleted.toString(), label: "Izbrisan", content: renderTabContent(rest) },
            { key: AdStatus.blocked.toString(), label: "Blokiran", content: renderTabContent(rest) },
            { key: AdStatus.expired.toString(), label: "Istekao", content: renderTabContent(rest) },
            { key: AD_DUPLICATE_TAB_KEY, label: "Duplikat", content: renderTabContent(rest) },
            { key: AdStatus.all.toString(), label: "Svi oglasi", content: renderTabContent(rest) },
          ]}
        />
        {isLoading && (
          <Spin className={styles.loading} tip={"Učitavam..."} size="large" />
        )}
      </div>
      <ShareLinkForm
        show={showShareLinkForm}
        onSubmit={onFormSubmit}
        values={formValues}
      />
      <PriceChanges
        values={priceChangeValues}
        show={showPriceChanges}
        onPriceChangesClose={onPriceChangesClose}
        onPriceChangesPageChange={onPriceChangesPageChange}
      />
      <StatusChanges
        statusChangesAdId={statusChangesAdId}
        setStatusChangesAdId={setStatusChangesAdId}
        statusChangesPostedDate={statusChangesPostedDate}
        setStatusChangesPostedDate={setStatusChangesPostedDate}
      />
    </React.Fragment>
  );
};

ManageAdPage.defaultProps = {
  modules: [],
  categories: [],
  showShareLinkForm: false
};

export default ManageAdPage;



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdPage/ManageAdPage.tsx